// ETG image URLs are `{size}`-templated and 404 unsubstituted — swap in a
// supported size token (1024x768 galleries, 240x240 thumbnails) before use.
function resolveImageUrl(url: string, size: string): string {
    return url.replace('{size}', size);
}

const brandImages = {
    hero: require('../../assets/images/hero_homepage.jpg'),
    bottomBannerHomepage: require('../../assets/images/bottombanner_homepage.png'),
    phuketMarriott: require('../../assets/images/marriott_hero.jpg'),
    outriggerMaldives: require('../../assets/images/outrigger_hero.jpg'),
    wafaifoHoiAn: require('../../assets/images/wafaifo_hero.jpg'),
    peninsulaBangkok: require('../../assets/images/peninsula_hero.jpg'),
    roomBedroom: require('../../assets/images/hotel-2.jpg'),
    roomCorridor: require('../../assets/images/hotel-3.jpg'),
    roomTerrace: require('../../assets/images/hotel-1.jpg'),
    roomBalconyCoast: require('../../assets/images/balcony-coast.jpg')
} as const;

// `images` is the reference UI's established name. Keep the alias so copied
// presentation components stay byte-for-byte close to the reference while
// existing target code can continue using `brandImages`.
const images = brandImages;

const LOCAL_ASSET_MAP: Record<string, any> = {
    'hotel-2.jpg': brandImages.roomBedroom,
    'hotel-3.jpg': brandImages.roomCorridor,
    'hotel-1.jpg': brandImages.roomTerrace,
    'balcony-coast.jpg': brandImages.roomBalconyCoast,
    'marriott_hero.jpg': brandImages.phuketMarriott,
    'outrigger_hero.jpg': brandImages.outriggerMaldives,
    'wafaifo_hero.jpg': brandImages.wafaifoHoiAn,
    'peninsula_hero.jpg': brandImages.peninsulaBangkok,
    'hero_homepage.jpg': brandImages.hero,
    'bottombanner_homepage.png': brandImages.bottomBannerHomepage,
};

function extractThumbnailUrl(source?: string | null): string | null {
    if (!source) return null;
    let raw = typeof source === 'string' ? source.trim() : '';
    if (!raw || raw === 'null' || raw === 'undefined') return null;

    if (raw.startsWith('{') && raw.endsWith('}')) {
        try {
            const parsed = JSON.parse(raw);
            if (parsed && typeof parsed.uri === 'string') {
                raw = parsed.uri;
            }
        } catch {}
    }

    if ((raw.startsWith('"') && raw.endsWith('"')) || (raw.startsWith("'") && raw.endsWith("'"))) {
        raw = raw.slice(1, -1).trim();
    }

    return raw || null;
}

function resolveThumbnailSource(source?: string | null): any | null {
    const raw = extractThumbnailUrl(source);
    if (!raw) return null;

    for (const [key, asset] of Object.entries(LOCAL_ASSET_MAP)) {
        if (raw.includes(key)) {
            return asset;
        }
    }

    if (raw.startsWith('http://') || raw.startsWith('https://') || raw.startsWith('/') || raw.startsWith('data:')) {
        return { uri: raw };
    }

    return null;
}

export { brandImages, extractThumbnailUrl, images, resolveImageUrl, resolveThumbnailSource };

